export default __webpack_public_path__ + "static/media/nurseImage.3db03cc5.jpg";